import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType } from "@/graphql";

const router: Router.LicensedRouterExportType = [
  {
    path: "/audit",
    name: "AuditOverview",
    component: () => import("./views/AuditList.vue"),
  },
  {
    path: "/AuditResultList/:id",
    name: "AuditResultList",
    redirect: (to) => {
      return {
        name: "AuditResultListWithFilter",
        params: {
          id: to.params.id,
          filter: "active",
        },
      };
    },
  },
  {
    path: "/AuditResultList/:id/:filter",
    name: "AuditResultListWithFilter",
    component: () => import("./views/AuditResultList.vue"),
  },
  {
    path: "/CreateAudit",
    name: "CreateAudit",
    component: () => import("./views/CreateAudit.vue"),
  },
  {
    path: "/UpdateAudit/:id/:revision",
    name: "UpdateAudit",
    component: () => import("./views/UpdateAudit.vue"),
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
      revision: route.params?.revision ? Number(route.params.revision) : undefined,
    }),
  },
  {
    path: "/auditResult/:id/:revision",
    name: "AuditResult",
    component: () => import("./views/AuditResult.vue"),
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
      revision: route.params.revision,
    }),
  },
  {
    path: "/appstore",
    name: "AppStore",
    component: () => import("./views/AppStore.vue"),
  },
  {
    path: "/audit/configOverview",
    name: "AuditResultConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["audit.createAudit"],
    },
    props: {
      internalTypes: [SQDCEventActionTypeInternalType.AuditResult],
      titleKey: "router.AuditResultConfigOverview",
      detailRouteName: "AuditResultConfigSettings",
    },
  },
  {
    path: "/audit/configOverview/:siteId",
    name: "AuditResultConfigSettings",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigSettings.vue"),
    meta: {
      rights: ["audit.createAudit"],
    },
    props: (route) => ({
      internalTypes: [SQDCEventActionTypeInternalType.AuditResult],
      siteId: Number(route.params.siteId),
      titleKey: "router.AuditResultConfigSettings",
    }),
  },
];

export default router;
